define('apps/course-intro/templates/items/level',['handlebars'], function(Handlebars) {

return Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\r\n    <a data-nav=\"route\" data-level=\"1\" href=\"#choose-modules/";
  if (stack1 = helpers.levelNum) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.levelNum); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "/";
  if (stack1 = helpers.guid) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.guid); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "\">\r\n        <h1>Level ";
  if (stack1 = helpers.levelNum) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.levelNum); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "</h1>\r\n        <span class=\"redundant-level level-";
  if (stack1 = helpers.levelNum) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.levelNum); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "\"></span>\r\n        <span class=\"get-started\">\r\n            Get started\r\n            <span class=\"fa fa-arrow-right\"></span>\r\n        </span>\r\n        <div class=\"player-asset\" data-guid=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.icon)),stack1 == null || stack1 === false ? stack1 : stack1.assetGuid)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-type-id=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.icon)),stack1 == null || stack1 === false ? stack1 : stack1.typeId)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"></div>\r\n        <h2>";
  if (stack2 = helpers.title) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.title); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</h2>\r\n        <div class=\"details\">\r\n            <h3>";
  if (stack2 = helpers.title) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.title); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</h3>\r\n            <p>";
  if (stack2 = helpers.description) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.description); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</p>\r\n            <span class=\"pill\">Start</span>\r\n        </div>\r\n    </a>\r\n";
  return buffer;
  }

function program3(depth0,data) {
  
  
  return "\r\n    <section class=\"lock-display\">\r\n        <span class=\"fa fa-lock\"></span>\r\n    </section>\r\n";
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isUnlocked), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n";
  return buffer;
  })

});
